export const GET_INDUSTRY='GET_INDUSTRY'
export const GET_CLIENT_LIST='GET_CLIENT_LIST'
export const SET_CLIENT_DETAIL='SET_CLIENT_DETAIL'
export const SET_FILTER='SET_FILTER'
export const RESET_DETAIL='RESET_DETAIL'